// extracted by mini-css-extract-plugin
export default {"postEditPage":"hnAun"};